import { PropsWithChildren, ReactElement, useEffect } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

// Components
import { Header } from 'components/Header';
import { Footer } from 'components/Footer';
import { Toast } from 'components/Toast';

// Store
import { isJASelector } from 'store/user/selectors';

interface IProps {
  hideSubnav?: boolean;
}

export const AuthenticatedLayout = (props: PropsWithChildren<IProps>): ReactElement => {
  const { children, hideSubnav } = props;
  const isJa: boolean = useSelector(isJASelector);

  useEffect(() => {
    // Scroll to top when the route has changed.
    window.scroll(0, 0);
  });

  return (
    <>
      <Header hideSubnav={hideSubnav} />
      <main className={classNames('main_layout', { ja: isJa })}>{children}</main>
      <Toast />
      <Footer />
    </>
  );
};
